import { __decorate, __metadata } from "tslib";
import { TypedStorage } from "./TypedStorage";
import { injectable } from "inversify";
let TypedSessionStorage = class TypedSessionStorage extends TypedStorage {
    constructor(key, defaultValue) {
        super(sessionStorage, key, defaultValue);
    }
};
TypedSessionStorage = __decorate([
    injectable(),
    __metadata("design:paramtypes", [String, Object])
], TypedSessionStorage);
export { TypedSessionStorage };
//# sourceMappingURL=TypedSessionStorage.js.map